import React, { useRef, useState, useEffect } from "react";
import Papa from "papaparse";
import { useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card, Box } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import ReactTable from "react-table";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "react-table/react-table.css";
import { DataGrid } from "@mui/x-data-grid";
import mime from "mime";
import { saveAs } from "file-saver";

export default function AddContainerList() {
  const history = useHistory();
  const csvRef = useRef(null);
  const [fileData, setFileData] = useState([]);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(true);

  const [tuglist, setTuglist] = useState([]);
  const [buglist, setbuglist] = useState([]);
  const [selectionModel, setSelectedRows] = useState([]);
  const EmpId = localStorage.getItem("EmpId");
  const [groupData, setGroupData] = useState([]);
  const columns1 = [
    { field: "No", headerName: "No", width: 150, },
    { field: "ContainerNo", headerName: "ContainerNo", width: 150, },
    { field: "SealNo", headerName: "SealNo", width: 150, },
    { field: "Size", headerName: "Size", width: 150, },
    { field: "BookingNo", headerName: "BOOKINGNO", width: 150, },
    { field: "GateOut", headerName: "Gate Out", width: 150, },
    { field: "GateIn", headerName: "Gate IN", width: 150, },

    { field: "VOYIN", headerName: "VOY IN", width: 150, },
    { field: "WagonNo", headerName: "WagonNo", width: 150, },
    { field: "TareWeight", headerName: "Tare Weight", width: 150, },
    { field: "CargoWeight", headerName: "Cargo Weight", width: 150, },
    { field: "Forwarding", headerName: "Forwarding", width: 150, },
    { field: "PortofLoading", headerName: "Port of Loading", width: 150, },
    { field: "PortofDischarge", headerName: "Port of Discharge", width: 150, },
    { field: "ShippingAgent", headerName: "Shipping Agent", width: 150, },
    { field: "ramark", headerName: "remark", width: 150, },

  ];

  const handleFileChange = async (event) => {
    const fileObj = event.target.files && event.target.files[0];

    let formData = new FormData();
    formData.append("fileUpload", fileObj);
    event.target.value = null;

    const result = await api
      .post(`api/containermovement/uploads`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        setData(res?.data);
      }).catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "ไม่สามารถใช้ไฟล์นี้ได้",
        });
      })

    return result;
  };
  // const makeColumns = (rawColumns) => {
  //   return rawColumns.map((column) => {
  //     return { Header: column, accessor: column };
  //   });
  // };

  // const handleDataChange = (file) => {
  //   setData(file.data);
  //   setColumns(makeColumns(file.meta.fields));
  // };
  // const handleChangeFile = (e) => {
  //   var file = csvRef.current.files[0];
  //   if (!file) return;
  //   setFileData(csvRef.current.files[0]);
  //   handleFileChange(file);
  // };

  //fetch commodity
  // const GetBranch = async () => {
  //   try {
  //     const data = await api.get("api/master/branch");
  //     // console.log(data.data.data);
  //     setBranchData(data.data.data);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };
  const getTug = async () => {
    try {
      const data = await api.get("api/tug/list?status=1");
      setTuglist(data?.data);
    } catch (e) {
      console.log(e);
    }
  };
  const getBarge = async () => {
    try {
      const data = await api.get("api/barge/list?status=1");
      setbuglist(data?.data);
    } catch (e) {
      console.log(e);
    }
  };

  //fetch Group
  const FetchGroup = async () => {
    try {
      const data = await api.get("api/master/group");
      setGroupData(data.data.data);
      //   console.log(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    FetchGroup();
    getTug();
    getBarge();
  }, []);

  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          รายการคอนเทนเนอร์
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Container List
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Planner</Typography>
            <Typography>
              <span>&nbsp;</span> / Add Container List
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{
            group: "",
            voy: "",
            tug: "",
            barge: "",
          }}
          validate={(values) => {
            const errors = {};
            // if (!values.branch || values.branch === "") {
            //   errors.branch = "Required";
            // }
            // if (!values.warehouse || values.warehouse === "") {
            //   errors.warehouse = "Required";
            // }
            // if (!values.import_date || values.import_date === "") {
            //   errors.import_date = "Required";
            // }
            // if (!values.import_time || values.import_time === "") {
            //   errors.import_time = "Required";
            // }
            if (!values.group || values.group === "") {
              errors.group = "Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                GroupShipment: values.group,
                Voyage: values.voy,
                Tug: values.tug,
                Barge: values.barge,
                Status: true,
                ImportContainermovement: selectionModel
              };
              api.post(`api/containermovement/createContainermovement`, data).then((res)=>
              {
                const MySwal = withReactContent(Swal);
                        MySwal.fire({
                          icon: "success",
                          didOpen: () => {
                            MySwal.clickConfirm();
                          },
                        }).then(() => {
                          return MySwal.fire(
                            "สำเร็จ!",
                            "เพิ่ม ContainerList สำเร็จ !",
                            "success"
                          ).then((result) => {
                            if (result.isConfirmed) {
                              history.push("/Planner/ContainerManagement");
                            }
                          });
                        });

              })

              setSubmitting(false)
            }, 1000);

            //   //   const data = {
            //   //     no: values.depots_name,
            //   //     name: values.depots_no,
            //   //     status: 1,
            //   //     createId: 1,
            //   //   };
            //   if (fileData.length !== 0) {
            //     let formData = new FormData();
            //     formData.append("fileUpload", fileData);
            //     formData.append("createId", EmpId);
            //     formData.append("groupId", values.group);
            //     formData.append("typeStockId", "1");
            //     formData.append("seq", "1");
            //     // console.log(fileData);
            //     console.log(formData);
            //     api
            //       .post("api/containermovement/uploads", formData, {
            //         headers: {
            //           "Content-Type": "multipart/form-data",
            //         },
            //       })
            //       .then((res) => {
            //         const MySwal = withReactContent(Swal);
            //         MySwal.fire({
            //           icon: "success",
            //           didOpen: () => {
            //             MySwal.clickConfirm();
            //           },
            //         }).then(() => {
            //           return MySwal.fire(
            //             "สำเร็จ!",
            //             "เพิ่ม ContainerList สำเร็จ !",
            //             "success"
            //           ).then((result) => {
            //             if (result.isConfirmed) {
            //               history.push("/Planner/ContainerList");
            //             }
            //           });
            //         });
            //         console.log(res);
            //       })
            //       .catch(() => {
            //         console.log("FAILURE!!");
            //       });
            //   } else {
            //     const MySwal = withReactContent(Swal);
            //     MySwal.fire(
            //       "กรุณาตรวจสอบไฟล์!",
            //       "กรุณาเลือกไฟล์อัพโหลด .csv เท่านั้น !",
            //       "info"
            //     );
            //   }
            //   setSubmitting(false);
            // }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                เพิ่มรายการคอนเทนเนอร์
              </h6>
              <Grid container>
                <Grid item xs={4} sm={4} md>
                  {/* <div style={{ marginBottom: 10 }}>
                    <FormControl sx={{ width: "50%", mr: "5px" }}>
                      <InputLabel>BRANCH</InputLabel>
                      <Select
                        name="branch"
                        label="BRANCH"
                        value={values.branch}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => {
                          setFieldValue("branch", e.target.value);
                          getWarehouse(e.target.value);
                        }}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="" disabled>
                          <em>เลือก Branch </em>
                        </MenuItem>

                        {branch_data.map((option, index) => {
                          return (
                            <MenuItem key={index} value={option.BranchId}>
                              {option.BranchName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    {errors.branch && touched.branch && errors.branch}
                  </div> */}
                  {/* <div style={{ marginBottom: 10 }}>
                    <FormControl sx={{ width: "50%", mr: "5px" }}>
                      <InputLabel>WAREHOUSE</InputLabel>
                      <Select
                        name="warehouse"
                        label="WAREHOUSE"
                        value={values.warehouse}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => {
                          setFieldValue("warehouse", e.target.value);
                        }}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="" disabled>
                          <em>เลือก Warehouse </em>
                        </MenuItem>

                        {warehouse_data.map((option, index) => {
                          return (
                            <MenuItem key={index} value={option.WarehouseId}>
                              {option.WarehouseName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    {errors.warehouse && touched.warehouse && errors.warehouse}
                  </div> */}
                  <FormControl sx={{ width: "50%", mr: "5px" }}>
                    <InputLabel>Group</InputLabel>
                    <Select
                      name="group"
                      label="Group"
                      value={values.group}
                      InputLabelProps={{ shrink: true }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <MenuItem value="" disabled>
                        <em>เลือก ประเภทการขนส่ง </em>
                      </MenuItem>
                      {groupData.map((option, index) => {
                        return (
                          <MenuItem key={index} value={option.GroupId}>
                            {option.GroupName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  {/* {values.group == 'G003' ? (
                    <div style={{ marginTop: 10 }}>
                      <TextField
                        name="voy"
                        label="Voy"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        sx={{ width: "50%" }}
                        value={values.voy}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </div>) : ''} */}
                  {/* {values.group == 'G003' ? (
                    <div style={{ marginBottom: 10 }}>
                      <FormControl
                        sx={{ width: "50%", mr: "5px", marginTop: "15px" }}
                      >
                        <InputLabel>Tug</InputLabel>
                        <Select
                          name="tug"
                          label="tug"
                          value={values.tug}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            setFieldValue("tug", e.target.value);
                          }}
                          onBlur={handleBlur}
                        >
                          <MenuItem value="" disabled>
                            <em>เลือก Tug </em>
                          </MenuItem>

                          {tuglist.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option.TugId}>
                                {option.TugName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>) : ''} */}
                  {/* {values.group == 'G003' ? (
                    <div style={{ marginBottom: 10 }}>
                      <FormControl
                        sx={{ width: "50%", mr: "5px", marginTop: "15px" }}
                      >
                        <InputLabel>Barge</InputLabel>
                        <Select
                          name="barge"
                          label="barge"
                          value={values.barge}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            setFieldValue("barge", e.target.value);
                          }}
                          onBlur={handleBlur}
                        >
                          <MenuItem value="" disabled>
                            <em>เลือก barge </em>
                          </MenuItem>

                          {buglist.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option.BargeId}>
                                {option.BargeName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>) : ''} */}

                  {/* <div style={{ marginTop: 10, marginBottom: 10 }}>
                    <TextField
                      name="import_time"
                      label="Import Time"
                      type="time"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.import_time}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300, // 5 min
                      }}
                      sx={{ width: "25%" }}
                    />
                    {errors.import_time &&
                      touched.import_time &&
                      errors.import_time}
                  </div> */}
                  <div style={{ marginBottom: 10, marginTop: "10px" }}>
                    <h6 style={{ marginTop: "10px", color: "#E74C3C" }}>
                      * กรุณาเลือกไฟล์อัพโหลด สกุลไฟล์ .csv เท่านั้น
                    </h6>

                    <input
                      type="file"
                      className="csv-form-control"
                      id="file"
                      accept=".csv"
                      ref={csvRef}
                      onChange={handleFileChange}
                    />
                  </div>
                  {data.length > 0 ? (
                    <Box sx={{ height: 400, width: "100%" }}>
                      <DataGrid
                        getRowId={(r) => r.No}
                        rows={data ? data : []}
                        columns={columns1}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        checkboxSelection
                        isRowSelectable={(params) => params.row.ramark === '' || null}
                        onSelectionModelChange={(ids) => {
                          
                          const selectedIDs = new Set(ids);
                          
                          const selectedRows = data.filter((row) => 
                            selectedIDs.has(row?.No?.toString())
                          );

                          setSelectedRows(selectedRows);
                        }}
                      />
                    </Box>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                  marginTop: "10px",
                }}
                onClick={history.goBack}
              >
                Cancel
              </Button>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                  marginTop: "10px",
                }}
                onClick={async () => {
                  await api
                    .get(`api/containermovement/download`, {
                      responseType: "blob",
                    })
                    .then((blobFile) => {
                      const blobFileRes = new File([blobFile?.data], "test.csv", {
                        type: mime.getType(".csv"),
                      });

                      // window.open(
                      //   URL.createObjectURL(blobFileRes, "test.csv"),
                      //   "_blank"
                      // );
                      saveAs(blobFileRes, "ตัวอย่าง.csv");
                    });
                }}
              >
                Dowload Template
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                  marginTop: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
